import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('tc-website-jobofferslist')

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement as HTMLElement)
    const keywordsPlaceholder = rootElement.dataset.keywordsPlaceholder ? rootElement.dataset.keywordsPlaceholder : 'Stichworte'
    const workplacesPlaceholder = rootElement.dataset.workplacesPlaceholder ? rootElement.dataset.workplacesPlaceholder : 'Arbeitsort'
    const noJobsText = rootElement.dataset.noJobsText ? rootElement.dataset.noJobsText : 'Keine Stellenangebote entsprechen den Suchkriterien'

    root.render(
        <React.StrictMode>
            <App keywordsPlaceholder={keywordsPlaceholder}
                 workplacesPlaceholder={workplacesPlaceholder}
                 noJobsText={noJobsText}/>
        </React.StrictMode>
    )
}
